import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { CssBaseline } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { LicenseInfo } from '@mui/x-license'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { msalConfig } from './features/auth/config.ts'
import { store } from './redux/store.ts'

async function enableMocking() {
  if (import.meta.env.MODE !== 'mock') return
  const { worker } = await import('../mock/browser')
  return worker.start({ serviceWorker: { url: '/n/mockServiceWorker.js' } })
}

const msalInstance = new PublicClientApplication(msalConfig)

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_KEY)

const root = ReactDOM.createRoot(document.getElementById('root')!)

function renderApp() {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BrowserRouter
              basename="/n"
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <CssBaseline />
              <App />
            </BrowserRouter>
          </LocalizationProvider>
        </Provider>
      </MsalProvider>
    </React.StrictMode>,
  )
}

// Process any pending redirect before rendering so MSAL has the account ready,
// avoiding a redundant ssoSilent/redirect cycle on return from B2C.
msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then(() => enableMocking())
  .then(renderApp)
  .catch((error) => {
    console.error('Startup failed:', error)
    renderApp()
  })
